import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import LogOut from "./../components/LogOut";
import editnumber from "../assets/pen-number.png";
import trashicon from "../assets/trash.png";

const CATEGORIES = [
  { value: "programming", label: "قسم البرمجة" },
  { value: "design", label: "قسم تصاميم" },
  { value: "other", label: "أخرى" },
];

const emptySection = () => ({
  title: "",
  description: "",
  image: null,
  category: "",
});

function Report() {
  const [showPopup, setShowPopup] = useState(false);
  const [analyses, setAnalyses] = useState([]);
  const [editPopup, setEditPopup] = useState(null);
  const [editForm, setEditForm] = useState({
    title: "",
    description: "",
    image: null,
    category: "",
    report_id: null,
  });
  const [sections, setSections] = useState([emptySection()]);

  const [clientId, setClientId] = useState("");
  const [clients, setClients] = useState([]);
  const [filterCategory, setFilterCategory] = useState("");
  // جلب العملاء
  useEffect(() => {
    const token = localStorage.getItem("token");
    fetch("http://backend.goldensection.agency/public/api/getuser", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        const list = Array.isArray(data) ? data : data.data || data.users || [];
        setClients(list);
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    if (clientId) fetchAnalyses(clientId);
    else setAnalyses([]);
  }, [clientId]);

  // const fetchAnalyses = async (cid) => {
  //   if (!cid) {
  //     setAnalyses([]);
  //     return;
  //   }
  //   try {
  //     const token = localStorage.getItem("token");
  //     const res = await fetch(
  //       `http://backend.goldensection.agency/public/api/reports/client/${cid}`,
  //       { headers: { Authorization: `Bearer ${token}` } }
  //     );
  //     const data = await res.json();
  //     const rows = [];
  //     Object.entries(data).forEach(([category, reports]) => {
  //       reports.forEach((report) => {
  //         report.sections.forEach((section) => {
  //           rows.push({ ...section, category, report_id: report.id });
  //         });
  //       });
  //     });
  //     setAnalyses(rows);
  //   } catch (err) {
  //     console.error("خطأ في جلب البيانات:", err);
  //   }
  // };

  // ---- إضافة ----
  const fetchAnalyses = async (cid) => {
    if (!cid) {
      setAnalyses([]);
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(
        `http://backend.goldensection.agency/public/api/reports/client/${cid}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      const data = await res.json();
      const rows = [];
      Object.entries(data).forEach(([category, reports]) => {
        reports.forEach((report) => {
          report.sections.forEach((section) => {
            rows.push({
              ...section,
              category,
              report_id: report.id,
              report_is_visible: report.is_visible,
            });
          });
        });
      });
      setAnalyses(rows);
    } catch (err) {
      console.error("خطأ في جلب البيانات:", err);
    }
  };
  const handleAddSection = () => {
    setSections([...sections, emptySection()]);
  };

  const handleChange = (index, field, value) => {
    const updated = [...sections];
    updated[index][field] = value;
    setSections(updated);
  };

  const handleSave = async () => {
    if (!clientId) {
      alert("اختر العميل أولاً");
      return;
    }
    try {
      const token = localStorage.getItem("token");

      const grouped = {};
      sections.forEach((s) => {
        if (!s.category) return;
        if (!grouped[s.category]) grouped[s.category] = [];
        grouped[s.category].push(s);
      });

      for (const [category, secs] of Object.entries(grouped)) {
        const formData = new FormData();
        formData.append("client_id", clientId);
        formData.append("category", category);

        secs.forEach((s, i) => {
          formData.append(`sections[${i}][title]`, s.title);
          formData.append(`sections[${i}][description]`, s.description || "");
          formData.append(`sections[${i}][sort_order]`, i);
          if (s.image) formData.append(`sections[${i}][image]`, s.image);
        });

        await fetch("http://backend.goldensection.agency/public/api/reports", {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        });
      }

      setShowPopup(false);
      setSections([emptySection()]);
      fetchAnalyses(clientId);
    } catch (err) {
      console.error("خطأ في الحفظ:", err);
    }
  };

  // ---- تعديل ----
  const openEdit = (item) => {
    setEditPopup(item.id);
    setEditForm({
      title: item.title,
      description: item.description,
      image: null,
      category: item.category || "",
      report_id: item.report_id,
    });
  };

  const handleEditSave = async () => {
    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();

      formData.append("sections[0][id]", editPopup);
      formData.append("sections[0][title]", editForm.title);
      formData.append("sections[0][description]", editForm.description || "");
      if (editForm.image) formData.append("sections[0][image]", editForm.image);
      formData.append("_method", "PUT");

      await fetch(
        `http://backend.goldensection.agency/public/api/reports/${editForm.report_id}`,
        {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        },
      );

      setEditPopup(null);
      fetchAnalyses(clientId);
    } catch (err) {
      console.error("خطأ في التعديل:", err);
    }
  };

  // ---- حذف ----
  const handleDelete = async (item) => {
    if (!window.confirm("هل أنت متأكد من الحذف؟")) return;
    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("sections[0][id]", item.id);
      formData.append("sections[0][_remove]", "1");
      formData.append("_method", "PUT");

      await fetch(
        `http://backend.goldensection.agency/public/api/reports/${item.report_id}`,
        {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        },
      );

      fetchAnalyses(clientId);
    } catch (err) {
      console.error("خطأ في الحذف:", err);
    }
  };

  // ---- label القسم ----
  const getCategoryLabel = (value) => {
    const found = CATEGORIES.find((c) => c.value === value);
    return found ? found.label : value;
  };
  const toggleSectionVisibility = async (item) => {
    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("sections[0][id]", item.id);
      formData.append("sections[0][is_visible]", item.is_visible ? "0" : "1");
      formData.append("_method", "PUT");

      await fetch(
        `http://backend.goldensection.agency/public/api/reports/${item.report_id}`,
        {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        },
      );

      fetchAnalyses(clientId);
    } catch (err) {
      console.error("خطأ في التبديل:", err);
    }
  };

  const toggleReportVisibility = async (item) => {
    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("is_visible", item.report_is_visible ? "0" : "1");
      formData.append("_method", "PUT");

      await fetch(
        `http://backend.goldensection.agency/public/api/reports/${item.report_id}`,
        {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        },
      );

      fetchAnalyses(clientId);
    } catch (err) {
      console.error("خطأ في التبديل:", err);
    }
  };
  return (
    <div className="seo-page">
      {/* Navbar */}
      <nav className="seo-navbar">
        <h1 className="nav-title">التقارير</h1>
        <LogOut />
        <button className="add1">
          <Link to="/admin">العودة للرئيسية</Link>
        </button>

        <select
          value={clientId}
          onChange={(e) => setClientId(e.target.value)}
          className="select1"
        >
          <option value="">-- اختر العميل --</option>
          {clients.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </select>
        <select
          value={filterCategory}
          onChange={(e) => setFilterCategory(e.target.value)}
          className="select2"
        >
          <option value="">جميع التقارير</option>
          <option value="programming">قسم البرمجة</option>
          <option value="design">قسم تصاميم</option>
          <option value="other">أخرى</option>
        </select>
        <button
          className="add4"
          onClick={() => {
            if (!clientId) {
              alert("اختر العميل أولاً");
              return;
            }
            setShowPopup(true);
          }}
        >
          إضافة محتوى
        </button>
      </nav>

      {/* جدول البيانات */}

      <div className="admin_area">
        <table className="users-table">
          <thead>
            <tr>
              <th>رقم السيكشن</th>
              <th>القسم</th>
              <th>المحتوى</th>
              <th>الإجراءات</th>
            </tr>
          </thead>
          <tbody>
            {analyses
              .filter((a) => !filterCategory || a.category === filterCategory)
              .map((a, index) => (
                <tr key={a.id}>
                  <td>{index + 1}</td>
                  <td>{getCategoryLabel(a.category)}</td>
                  <td>
                    <strong>{a.title}</strong>
                    <p>{a.description}</p>
                    {a.image && (
                      <img
                        src={a.image.replace(
                          "http://localhost/storage",
                          "http://backend.goldensection.agency/public/api/storage",
                        )}
                        alt={a.title}
                        style={{ width: "100px", height: "auto" }}
                      />
                    )}
                  </td>
                  <td>
                    <button className="delete-btn" onClick={() => openEdit(a)}>
                      <img src={editnumber} alt="edit" />
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(a)}
                    >
                      <img src={trashicon} alt="delete" />
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() => toggleSectionVisibility(a)}
                      title="إخفاء/إظهار السيكشن"
                    >
                      {a.is_visible ? (
                        <i class="fa-solid fa-eye-slash"></i>
                      ) : (
                        <i class="fa-solid fa-eye"></i>
                      )}
                    </button>
                    {/* <button
                    className="delete-btn"
                    onClick={() => toggleReportVisibility(a)}
                    title="إخفاء/إظهار القسم كله"
                  >
                    {a.report_is_visible ? (
                      <i class="fa-solid fa-toggle-off"></i>
                    ) : (
                      <i class="fa-solid fa-toggle-on"></i>
                    )}
                  </button> */}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {/* Popup الإضافة */}
      {showPopup && (
        <div className="popup-overlay">
          <div
            className="popup"
            style={{ maxHeight: "80vh", overflowY: "auto" }}
          >
            <button className="cancel-btn" onClick={() => setShowPopup(false)}>
              ×
            </button>
            <h3>إضافة محتوى</h3>

            {sections.map((s, index) => (
              <div key={index} className="section-form">
                <h4>سيكشن {index + 1}</h4>

                <label>القسم</label>
                <select
                  value={s.category}
                  onChange={(e) =>
                    handleChange(index, "category", e.target.value)
                  }
                >
                  <option value="">-- اختر القسم --</option>
                  {CATEGORIES.map((cat) => (
                    <option key={cat.value} value={cat.value}>
                      {cat.label}
                    </option>
                  ))}
                </select>

                <label>العنوان</label>
                <input
                  type="text"
                  value={s.title}
                  onChange={(e) => handleChange(index, "title", e.target.value)}
                />

                <label>الوصف</label>
                <input
                  type="text"
                  value={s.description}
                  onChange={(e) =>
                    handleChange(index, "description", e.target.value)
                  }
                />

                <label>الصورة</label>
                <input
                  type="file"
                  onChange={(e) =>
                    handleChange(index, "image", e.target.files[0])
                  }
                />
              </div>
            ))}

            <button className="add5" onClick={handleAddSection}>
              إضافة سيكشن جديد
            </button>
            <button className="save-btn" onClick={handleSave}>
              حفظ
            </button>
          </div>
        </div>
      )}

      {/* Popup التعديل */}
      {editPopup && (
        <div className="popup-overlay">
          <div
            className="popup"
            style={{ maxHeight: "80vh", overflowY: "auto" }}
          >
            <button className="cancel-btn" onClick={() => setEditPopup(null)}>
              ×
            </button>
            <h3>تعديل المحتوى</h3>

            <label>العنوان</label>
            <input
              type="text"
              value={editForm.title}
              onChange={(e) =>
                setEditForm({ ...editForm, title: e.target.value })
              }
            />

            <label>الوصف</label>
            <input
              type="text"
              value={editForm.description}
              onChange={(e) =>
                setEditForm({ ...editForm, description: e.target.value })
              }
            />

            <label>الصورة</label>
            <input
              type="file"
              onChange={(e) =>
                setEditForm({ ...editForm, image: e.target.files[0] })
              }
            />

            <button className="save-btn" onClick={handleEditSave}>
              حفظ
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Report;
